export default {
  // Generic actions
  actions: {
    cancel: "Cancel",
    close: "Close",
    save: "Save",
    add: "Add",
    edit: "Edit",
    apply: "Apply",
    confirm: "Confirm",
    delete: "Delete",
    remove: "Remove",
    refresh: "Refresh",
    reset: "Reset Changes",
    reset_short: "Reset",
  },

  // Generic messages
  messages: {
    loading: "Loading...",
    loading_info: "Loading information...",
    saving: "Saving changes...",
    deleting: "Deleting...",
    noData: "No data available",
    error: "An error occurred",
  },

  // Common button patterns
  buttons: {
    clearAll: "Clear all",
    selectAll: "Select all",
    deselectAll: "Deselect all",
  },

  // Unsaved-changes guard dialog
  unsaved: {
    subtitle: "You have unsaved changes.",
    body: "Would you like to save your changes before closing, or discard them?",
  },

  optional: "optional",

  titles: {
    sample_info: "Sample Information: {barcode}",
  },

  //
  // Sample Info Dialog
  //
  sample_info: {
    tabs: {
      basic_info: "Basic Information",
      instruments: "Instruments",
      results_sets: "Results Sets",
    },

    results_sets_table: {
      group_name: "Set",
    },
  },
};
